import React from "react"
import Relay from "react-relay"
import shallowCompare from "react-addons-shallow-compare"
import Resource from "../modules/Resource"
import Article from "../modules/Article"
import State from "../../stores/State"
import { roleCanEdit } from "../../scripts/user"
import { withRouter } from "react-router"
import { apiAuth } from "../../api"

class Item extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      canEdit: roleCanEdit(),
      userId: State.get("userId"),
      updated: false,
      user: {}
    }
  }

  componentWillMount() {
    // 404 handling
    if (!this._canView()) {
      if (typeof window !== "undefined") {
        // Client Side
        // HACK I can't work out how do anything better client side currently;
        // This exception can't be caught in app.js for some reason.
        // Maybe related. https://github.com/facebook/react/issues/2461
        window.location.href = "/404.html"
        return null
      } else {
        //Server side, this handled in renderOnServer
        throw new Error("404")
      }
    }
  }

  render() {
    const resource = this.props.resource
    const style = resource.type

    const editing =
      this.props.location.query &&
      this.props.location.query.edit &&
      this._canEdit()

    const collectionItemsIds =
      "resources_collections" in this.props.viewer
        ? this.props.viewer.resources_collections[0].collected.edges.map(
            item => item.node.id
          )
        : []

    if (!this._canView()) {
      //Shouldn't actually get this far, see componentWillMount
      return null
    }

    return (
      <main data-article-style={style} tabIndex={0} role="main" id="main">
        {resource.type === "article" && (
          <Article
            editing={editing}
            canEdit={this.state.canEdit || this._canEdit()}
            resource={resource}
            user={this.state.user}
            handleSave={this._handleSave}
            handleUnsaved={this._handleUnsaved}
          />
        )}
        {resource.type !== "article" && (
          <Resource
            child={this.props.child}
            file={this.props.file}
            canEdit={this.state.canEdit || this._canEdit()}
            userSets={this.props.userSets}
            userFavourite={this.props.userFavourite}
            viewer={this.props.viewer}
            user={this.state.user}
            resource={resource}
            resourcesIds={collectionItemsIds}
            urlParams={this.props.params}
            isFromCollections
          />
        )}
      </main>
    )
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState)
  }

  componentDidMount() {
    window.scrollTo(0, 0)

    apiAuth("get", "user").then(values => this.setState({ user: values }))

    this._stateListener = State.addListener(() => {
      const canEdit = roleCanEdit()
      const userId = State.get("userId")
      if (canEdit !== this.state.canEdit || userId !== this.state.userId) {
        this.setState({ canEdit, userId })
      }
    })
  }

  componentWillUnmount() {
    if (this._stateListener) {
      this._stateListener.remove()
    }
  }

  _handleSave = res => {
    this.setState({
      updated: true
    })
  }

  _handleUnsaved = () => {
    this.setState({
      updated: false
    })
  }

  _canView() {
    const { resource } = this.props
    const { access_rights: accessRights } = resource
    const {
      contributor_id: contributorId = {
        value: ""
      }
    } = JSON.parse(resource.custom_fields)

    return (
      (accessRights && accessRights === "published") ||
      (contributorId && this.state.userId === contributorId.value)
    )
  }

  _canEdit() {
    const { resource } = this.props
    const {
      contributor_id: contributorId = {
        value: ""
      }
    } = JSON.parse(resource.custom_fields)

    return (
      this.state.canEdit ||
      (contributorId && this.state.userId === contributorId.value)
    )
  }
}

export default Relay.createContainer(withRouter(Item), {
  initialVariables: {
    uuid: "",
    itemUuid: "",
    includeCollectionsIds: false
  },
  prepareVariables: prevVariables => ({
    ...prevVariables,
    includeCollectionsIds: !!prevVariables.itemUuid
  }),
  fragments: {
    resource: () => Relay.QL`
    fragment on Resource {
        id
        type
        access_rights
        custom_fields
        ${Resource.getFragment("resource")}
        ${Article.getFragment("resource")}
    }
    `,
    viewer: () => Relay.QL`
      fragment on Viewer {
        ${Resource.getFragment("viewer")}

        resources_collections(id: $uuid) @include(if: $includeCollectionsIds) {
          collected(first: 50) {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/pages/Item.js